import React, { useEffect } from "react";
import { Box } from "@mui/material";
import bgImage from "../../assets/images/BG.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "@store/store";
import { setToken, setIsUserLoggedIn } from "../login/redux/loginSlice";

const Redirect = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Try to extract token from query, hash or pathname
    const searchParams = new URLSearchParams(location.search);
    let token = searchParams.get("access-token") 

    // If not in query, check hash (e.g. #access-token=...)
    if (!token && location.hash) {
      const hash = location.hash.replace(/^#/, "");
      const hashParams = new URLSearchParams(hash);
      token = hashParams.get("access-token") || hashParams.get("access_token") || hashParams.get("token");
      if (!token && hash.includes("access-token=")) {
        const parts = hash.split("access-token=");
        token = parts[1] ? decodeURIComponent(parts[1].split(/[&/#?]/)[0]) : null;
      }
    }

    // If still not found, check pathname pattern: /redirect/access-token=XYZ
    if (!token && location.pathname) {
      const p = location.pathname;
      const idx = p.indexOf("access-token=");
      if (idx !== -1) {
        token = decodeURIComponent(p.substring(idx + "access-token=".length).split(/[/?#]/)[0]);
      }
    }
    console.log("Extracted token:", token);
    if (token) {
      try {
        // store token in redux and localStorage so login can pick it up
        dispatch(setToken(token));
        dispatch(setIsUserLoggedIn(true));
        // localStorage.setItem("access_token", token);
        navigate("/application-dashboard");
      } catch (err) {
        // If anything goes wrong, still redirect to login
        navigate("/", { replace: true });
      }
    } else {
      // No token found — redirect to login
      navigate("/", { replace: true });
    }
  }, [location, navigate, dispatch]);

  return (
    <Box sx={{
        padding: '20rem 0',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.5rem',
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '80vh',
        color: '#333',
    }}>
      Redirecting to rajmarg pravesh...
    </Box>
  );
};

export default Redirect;
